import type { IconSvgObject } from './types';

const SaudiRiyalIcon: IconSvgObject = [
  ["path", { d: "M10 3V13.6754C10 15.7626 10 16.8062 9.43373 17.5919C8.86745 18.3775 7.87742 18.7075 5.89737 19.3675L4 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 3V12.0217C14 14.4102 14 15.6044 14.7962 16.1933C15.5924 16.7823 16.7622 16.4533 19.1018 15.7954L20 15.5428", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 21L20 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 15L20 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default SaudiRiyalIcon;
